module.exports = __webpack_public_path__ + "img/pathology-relapse.9103287a.png";